import React, { useState, useEffect } from 'react';
import Markdownkatexnew from "./Markdown.js";
import axios from "axios"
import { isAuth } from '../helpers/auth';
import MathRenderer from "../components/taskUser copy 3.js"
import { ToastContainer, toast } from "react-toastify";
import Select, { components } from 'react-select';
import WindowFocusHandler from "./isvisible.js";
import Timer from './timer.js';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import { useHistory } from "react-router-dom";
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
timeago.register('es', es);

const ExportToExcel = ({ idtheme, codetheme, task_id }) => {

  const history = useHistory();
  const [value, setValue] = useState('')
  const [evaluacion, setEvaluacion] = useState("2")
  const [show, setShow] = useState(true)
  const [items, setItems] = useState([])
  const [taskss, setTaskss] = useState()
  const [datee, setDatee] = useState()

  const [secondsRemaining, setSecondsRemaining] = useState(5)

  useEffect(() => {
    getTask()
  }, []);

  const getTask = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/tasks/test/${idtheme}/${codetheme}/${isAuth()._id}`)
      .then((response) => response.json())
      .then(async (www) => {
        // console.log(www[0], "wwwgetask")
        if (www.length > 0) {
          setTaskss(www[0])
          setItems(www[0].items)
          setDatee(www[0].datee)
          var encuestas = www[0].items
          var rptas = []
          if (encuestas.length > 0) {
            for (var j = 0; j < encuestas.length; j++) {
              if (encuestas[j].std === encuestas[j].rpta) {
                rptas.push(1)
              } else {
                rptas.push(0)
              }
            }
          }
          setEvaluacion(rptas.filter(x => x === 1).length)
        }
      })
  };

  const EndTest = async () => {
    if (window.confirm('Desea guardar y evaluar su test?')) {
      await axios.put(`${process.env.REACT_APP_API_URL}/tasks/test/${task_id}`, { datee: new Date() }).then((www) => {
        toast.success(www.data)
        getTask()
      }).catch((error) => { console.log("ERROR", error.response) })
    }
  }

  const sendTest = async (w, ww) => {
    function getLevenshteinSimilarity(str1, str2) {
      const track = Array(str2.length + 1).fill(null).map(() =>
        Array(str1.length + 1).fill(null)
      );
      for (let i = 0; i <= str1.length; i += 1) track[0][i] = i;
      for (let j = 0; j <= str2.length; j += 1) track[j][0] = j;
      for (let j = 1; j <= str2.length; j += 1) {
        for (let i = 1; i <= str1.length; i += 1) {
          const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
          track[j][i] = Math.min(
            track[j - 1][i] + 1, // deletion
            track[j][i - 1] + 1, // insertion
            track[j - 1][i - 1] + indicator // substitution
          );
        }
      }
      const distance = track[str2.length][str1.length];
      const maxLength = Math.max(str1.length, str2.length);
      if (maxLength === 0) return 100;
      return ((maxLength - distance) / maxLength) * 100;
    }

    var newww = w
    var rptas = []
    for (var j = 0; j < newww.length; j++) {
      if (newww[j].alt) {
        if (newww[j].std === newww[j].rpta) {
          rptas.push(1)
        } else {
          rptas.push(0)
        }
      } else {
        rptas.push(3 * getLevenshteinSimilarity(newww[j].std, newww[j].obs) / 100)
      }
    }
    // setItems(encuestas)
    // setEvaluacion(rptas.filter(x => x === 1).length)
    console.log(rptas)
    const totalSum = rptas.reduce((accumulator, currentString) => accumulator + +currentString, 0);
    console.log(totalSum)

    await axios.put(`${process.env.REACT_APP_API_URL}/tasks/test/${task_id}`, { items: w, note: totalSum }).then((www) => {
      toast.success(www.data)
      getTask()
    }).catch((error) => { console.log("ERROR", error.response) })
  }

  const onChange = (text) => (e) => {
    var encuestas = items
    encuestas[text].std = e.label[0]

    console.log(evaluacion)
    if (encuestas != null) { sendTest(encuestas) }
  }

  const onChangett = (text, i) => {
    function getLevenshteinSimilarity(str1, str2) {
      const track = Array(str2.length + 1).fill(null).map(() =>
        Array(str1.length + 1).fill(null)
      );
      for (let i = 0; i <= str1.length; i += 1) track[0][i] = i;
      for (let j = 0; j <= str2.length; j += 1) track[j][0] = j;
      for (let j = 1; j <= str2.length; j += 1) {
        for (let i = 1; i <= str1.length; i += 1) {
          const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
          track[j][i] = Math.min(
            track[j - 1][i] + 1, // deletion
            track[j][i - 1] + 1, // insertion
            track[j - 1][i - 1] + indicator // substitution
          );
        }
      }
      const distance = track[str2.length][str1.length];
      const maxLength = Math.max(str1.length, str2.length);
      if (maxLength === 0) return 100;
      return ((maxLength - distance) / maxLength) * 100;
    }

    var encuestas = items
    
    var rrr = text.replace(/<\/span>/g, '').replace(/<span class="math-tex">/g, '')
    console.log(rrr, encuestas[i].obs)
    console.log(rrr.length, encuestas[i].obs.length)
    if (encuestas[i].std.length <= encuestas[i].obs.length) {
      encuestas[i].std = text
      setItems(encuestas)
      if (encuestas != null) { sendTest(encuestas) }
    } else {
      toast.info("Exceso de texto")
    }

  }


  const MarkdownOption = (props) => {
    // console.log(props.data.value)
    return (
      <components.Option {...props}>
        <MathRenderer>{props.data.value[0]}</MathRenderer>
      </components.Option>
    );
  };

  const MarkdownSingleValue = (props) => {
    // console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <MathRenderer>{props.data.value[0]}</MathRenderer>
      </components.SingleValue>
    );
  };

  const handleDataFromChild = (data) => {
    // WindowFocusHandler
    history.push(`/curso/${idtheme}`)
    console.log(idtheme)
    setShow(false);
  };

  const handleFromChild = (data) => {
    setSecondsRemaining(0)
    console.log(data)
    // this.props.history.push(`/curso/${this.props.match.params.theme}`)
    setShow(false);
  };


  return (
    <div>
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />

      {taskss && isAuth().rol != '1' ?
        <div>
          <div>
            {secondsRemaining === 0 ?
              <div className='text-center w-100'>
                <span className='text-center text-warning'>Culminó la evaluación {value} - {idtheme} {codetheme}</span><br />
                <span className='text-center text-info'>Crédito: {evaluacion}</span><br />
                {taskss.dateb} {taskss.datee}
              </div>
              :
              <div>
                {show ? <div>
                  <Timer endDate={datee} onFinish={handleFromChild} />
                  <WindowFocusHandler onDataReceived={handleDataFromChild} />
                  <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
                    {items.map((number, i) =>
                      <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12 p-1'}`}>
                        <div className="p-1 border border-light rounded">
                          [{i + 1}]
                          <MathRenderer className="text-black">
                            {number.prg}
                          </MathRenderer>
                          {number.alt ? <MathRenderer className="text-info">
                            {number.std}
                          </MathRenderer> : ''}
                          {number.alt ?
                            <div className='marginbottomp'>
                              <Select onChange={onChange(i)} defaultValue={number.alt.filter(({ value }) => value === number.std)} options={
                                number.alt.map((guest, index) => {
                                  return {
                                    label: guest,
                                    value: guest,
                                    key: index
                                  }
                                })
                              } components={{ Option: MarkdownOption, SingleValue: MarkdownSingleValue }} />
                            </div>
                            :
                            <CKEditor editor={ClassicEditor} config={{
                              // plugins: [Math, /* ... other plugins */],
                              language: 'es', placeholder: "Descripción",
                              toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                              math: {
                                engine: 'katex', // or 'mathjax'
                                outputType: 'span', // 'span' or 'script'
                                forceOutputType: false,
                                enablePreview: true
                              }
                            }}
                              data={number.std.includes("math-tex") ? number.std : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                              onBlur={(event, editor) => {
                                onChangett(editor.getData(), i)
                              }}
                              onReady={editor => {
                                // console.log('Editor is ready to use!', editor)
                              }}
                            // name="detail"
                            />

                          }
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='text-center text-warning h5'>
                    <button type="submit" onClick={EndTest} className='btn btn-warning'>
                      Guardar y evaluar
                    </button>
                  </div>
                </div> : <div className='text-center text-warning'>Mantener la ventana en foco (Actualiza solo esta vez)</div>}
              </div>
            }
          </div>
        </div>
        : ''}
    </div >
  );
};

export default ExportToExcel